import loadable, { DefaultComponent } from '@loadable/component';
import React, { ReactElement } from 'react';

import ContactFlyoutProps from './ContactFlyoutProps';

const ContactFlyout = loadable(
    (): Promise<DefaultComponent<ContactFlyoutProps>> => import(/* webpackChunkName: "ContactFlyout" */ './ContactFlyout'),
);
const ContactFlyoutLoader = (props: ContactFlyoutProps): ReactElement => <ContactFlyout {...props} />;
export default ContactFlyoutLoader;
